// EmailJS Configuration for CS2 Lineups
// Target Email: cs2lineups.info@gmail.com
// 
// To set up EmailJS for your clip submission form:
// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Create a new email service (Gmail recommended for cs2lineups.info@gmail.com)
// 3. Create a new email template
// 4. Replace the placeholder values below with your actual EmailJS credentials

export const emailjsConfig = {
  // Your EmailJS service ID (from the EmailJS dashboard)
  serviceId: 'service_870eihj',
  
  // Your EmailJS template ID (from the EmailJS dashboard)
  templateId: 'template_ci0fb9p',
  
  // Your EmailJS public key (from the EmailJS dashboard)
  publicKey: 'qUi5j5iSEUsY7q6G3'
};

// Example email template variables (for reference when creating your template):
// {{from_name}} - Submitter's name
// {{from_email}} - Submitter's email
// {{gamer_tag}} - Gamer tag or Steam name for credit
// {{social_links}} - Social media links
// {{map_name}} - Selected map
// {{clip_type}} - Type of clip (smoke, flash, etc.)
// {{description}} - Clip description
// {{clip_url}} - URL to the clip
// {{additional_notes}} - Additional notes
// {{attachment_count}} - Number of files attached
// {{file_urls}} - Cloudinary URLs for uploaded files
// {{submission_id}} - Unique submission identifier

// Sample EmailJS template content:
/*
Subject: New CS2 Clip Submission from {{from_name}}

Hello!

You have received a new clip submission for your CS2 Lineups website.

Submitter Details:
- Name: {{from_name}}
- Email: {{from_email}}
- Gamer Tag: {{gamer_tag}}
- Social Links: {{social_links}}
- Submission ID: {{submission_id}}

Clip Details:
- Map: {{map_name}}
- Type: {{clip_type}}
- URL: {{clip_url}}

Description:
{{description}}

Additional Notes:
{{additional_notes}}

Attachments:
{{attachment_count}}
{{file_urls}}

---
Submitted via CS2 Lineups - Submit Clip Form
Sent to: cs2lineups.info@gmail.com
*/ 